import { Bell } from '@/ui/icons'
import { useBackendNotificationsRealtime } from '@/shared/hooks/useNotificationsRealtime'
import { useNotificationsPanel } from '@/contexts/NotificationsPanelContext'
import { Button } from '../primitives/button'
import { Badge } from '../primitives/badge'
import { cn } from '@/shared/utils'

interface NotificationTriggerProps {
  className?: string
}

export function NotificationTrigger({ className }: NotificationTriggerProps) {
  const { unreadCount } = useBackendNotificationsRealtime({ limit: 1 })
  const { openNotificationsPanel } = useNotificationsPanel()

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('relative h-11 w-11 md:h-9 md:w-9', className)}
      onClick={openNotificationsPanel}
      aria-haspopup="dialog"
      aria-label="Open notifications"
    >
      <Bell className="h-6 w-6" />
      {unreadCount > 0 && (
        <Badge
          className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs"
          variant="destructive"
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </Badge>
      )}
      <span className="sr-only">{unreadCount} unread notifications</span>
    </Button>
  )
}
